import { createMuiTheme } from '@material-ui/core/styles';

const DARK_BLUE = '#0095c8';

export default createMuiTheme({
  palette: {
    primary: {
      main: DARK_BLUE,
    },
  },
  typography: {
    h1: {
      color: '#54585a',
      fontFamily: ['Raleway', 'serif'],
    },
    h4: {
      color: '#54585a'
    },
    subtitle1: {
      fontSize: '1rem',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 400,
      lineHeight: 1.5,
      letterSpacing: '0.00938em',
      color: 'rgba(0, 0, 0, 0.54)',
    },
    p: {
      fontFamily: ['Merriweather', 'serif'],
      fontWeight: 400,
      fontSize: '18px',
      lineHeight: 1.6,
      color: '#54585a',
    },
  },
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: '0.85em',
      },
    },
    MuiToggleButton: {
      // Override the styling for selected toggle buttons
      root: {
        '&$selected': {
          backgroundColor: DARK_BLUE,
          color: 'white',
        },
      },
    },
    MuiButton: {
      root: {
        borderRadius: 0,
        backgroundColor: '#fff',
        fontSize: '20px',
        fontWeight: 700,
        fontFamily: ['Raleway', 'sans-serif'],
        border: '3px solid #0095c8',
        textTransform: 'capitalize',
        position: 'relative',
        
        '&:before': {
          content: '',
          display: 'block',
          position: 'absolute',
          width: 0,
          height: '100%',
          backgroundColor: '#0095c8',
          left: 0,
          bottom: 0,
          transition: '.2s',
          animation: 'ease-in-out',
          zIndex: 1,
        },
        '&:hover:before': {
          width: '100%',
        },
      },
      label: {
        zIndex: 10,
      },
      contained: {
        boxShadow: 'none'
      },
      containedPrimary: {
        borderRadius: 0,
        backgroundColor: '#fff',
        color: '#0095c8',
        '&:hover': {
          color: '#fff',
          backgroundColor: '#0095c8'
        }
      }
    },
    MuiOutlinedInput: {
      notchedOutline: {
        border: 'none',
      },
    },
    MuiInputBase: {
      root: {
        borderRadius: 0,
      },
      input: {
        borderRadius: 0,
        boxShadow: 'none',
        backgroundColor: 'rgba(158, 162, 162, 0.1)',
        border: 'none',
        fontFamily: ['Merriweather', 'serif'],
      },
    },
  },
});
